module.exports = __webpack_public_path__ + "img/ingenieria_msh.a5582c16.jpg";